export var Privacy;
(function(Privacy) {
    Privacy["PrivateEphemeral"] = "private-ephemeral";
    Privacy["Public"] = "public";
})(Privacy || (Privacy = {}));
export var Region;
(function(Region) {
    Region["America"] = "us";
    Region["Germany"] = "de";
})(Region || (Region = {}));
